module.exports = __webpack_public_path__ + "static/media/about_02.484387d4.jpg";